import { gql } from "@apollo/client";

export const REGION_FRAGMENT = gql`
  fragment RegionPart on Region {
    id
    name
  }
`;

export const REGIONS = gql`
  query RegionsQuery($where: RegionsFiltersInput!) {
    regions(where: $where) {
      hasMore
      results {
        ...RegionPart
      }
    }
  }
  ${REGION_FRAGMENT}
`;
